import { Dispatch, SetStateAction } from 'react';
import { FormInstance } from 'antd';
import { debounce, reduce } from 'lodash';

import { pushItemInArrayWithState } from 'utils';

import { TEditableColumn } from 'types';

export const handleScrollToLastRow = () => {
  const element = document.querySelector('tr[data-row-key="0"]');

  element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const handleValidateOnChange = <T, >(
  form: FormInstance<T>,
  setIsFormValid: (status: boolean) => void,
) => debounce(async () => {
  try {
    await form.validateFields();
    setIsFormValid(true);
  } catch (error) {
    setIsFormValid(false);
  }
  // hack for be able to test parent components
}, import.meta.env.MODE === 'test' ? 0 : 250);

export const handleAddRow = <T extends Record<string, unknown>>({
  columns,
  setEditingKey,
  setEditableTableData,
}: {
  columns: TEditableColumn<T>[];
  setEditingKey: (key: 0) => void;
  setEditableTableData: Dispatch<SetStateAction<T[] | undefined>>;
}) => () => {
  const newData = reduce<TEditableColumn<T>, { [key: string]: string | number }>(columns, (acc, column) => {
    if (column.field && typeof column.dataIndex === 'string') {
      acc[column.dataIndex] = '';
    }

    if (Array.isArray(column.dataIndex)) {
      const dataIndex = column.dataIndex.join('.');

      acc[dataIndex] = '';
    }

    return acc;
  }, { id: 0, key: 0 }) as T;

  setEditingKey(0);
  pushItemInArrayWithState(newData, setEditableTableData);
};
